import { s as u } from "./index.es-B8mbAxS4.js";
const i = (r) => String(r) === "[object Object]";
function s(r) {
  if (!i(r))
    return !1;
  const e = r.constructor;
  if (e === void 0)
    return !0;
  const t = e.prototype;
  return !(!i(t) || !t.hasOwnProperty("isPrototypeOf"));
}
function f(r, e) {
  if (r === e)
    return !0;
  if (r instanceof Date && e instanceof Date)
    return r.getTime() === e.getTime();
  if (Array.isArray(r) && Array.isArray(e))
    return r.length !== e.length ? !1 : r.every((t, n) => f(t, e[n]));
  if (s(r) && s(e)) {
    const t = Object.entries(r);
    return t.length !== Object.keys(e).length ? !1 : t.every(([n, c]) => f(c, e[n]));
  }
  return !1;
}
function o(r) {
  return (...e) => {
    u((t) => {
      (t.internal.context.mode.isPreview() ? console[r] : t.internal.logger[r])(...e);
    });
  };
}
const a = {
  debug: o("debug"),
  info: o("info"),
  warn: o("warn"),
  error: o("error")
};
export {
  s as a,
  f as i,
  a as l
};
